import React, { Component } from "react";
import {Button, Col, Modal, Row} from "antd";
import SuccessIcon from '../../assets/success-icon.svg';
import {injectIntl} from "react-intl";
import PrivacyAndTermsFooter from "../sign-in-modal/PrivacyAndTermsFooter";

export class SuccessRegisterModal extends Component {
  constructor(props) {
    super(props);

    this.state = {

    }
  }
  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      message = intl.formatMessage({ id: 'sign_up.message_validation' }),
      handleShowInsertCodeVerify
    } = this.props;

    return (
      <React.Fragment>
        <Modal
          visible={showModal}
          onCancel={handleHiddenModal}
          width={540}
          footer={null}
          centered
        >
          <Row justify={'center'}>
            <Col span={24} style={{ textAlign: 'center', }}>
              <img src={SuccessIcon} alt="Success icon" style={{ marginBottom: 10 }} />
              <div style={{ fontSize: 21, }}>{intl.formatMessage({ id: 'sign_up.success' })}</div>
              <div style={{ fontSize: 16, fontWeight: 400 }}>{message}</div>
            </Col>
          </Row>
          <br/>
          <Row>
            <Button
              size={'large'}
              type={'primary'}
              block
              style={{ height: 57, }}
              onClick={handleShowInsertCodeVerify}
            >
              {intl.formatMessage({ id: 'sign_up.next_code' })}
            </Button>
          </Row>
          <br/>
          <PrivacyAndTermsFooter/>
        </Modal>


      </React.Fragment>
    )
  }
}

export default injectIntl(SuccessRegisterModal)
